var _circle, _path, _path2, _circle2, _path3, _circle3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEinzel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.533 14.49a1.312 1.312 0 0 0-1.249 1.362V36.976H43.06l2.704-6.646V15.852a1.312 1.312 0 0 0-1.25-1.361h-29.98Z",
  fill: "#EDF4F3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.059 36.976 41.784 40.1h-27.25a1.312 1.312 0 0 1-1.25-1.362v-1.76H43.06ZM36.394 40.1l-1.874 3.123h-1.092l-.156 2.498H21.405a1.259 1.259 0 0 1-1.25-1.25c.002-.688.56-1.246 1.25-1.248h1.873l1.873-3.123h11.243Z",
  fill: "#405B73"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 41.391,
  cy: 33.853,
  r: 5.621,
  fill: "#FDD7AD"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.272 48.843v-4.372a4.997 4.997 0 0 1 4.996-4.996h6.246a4.997 4.997 0 0 1 4.997 4.996v4.373a1.874 1.874 0 0 1-1.874 1.873H35.145a1.874 1.874 0 0 1-1.873-1.873Z",
  fill: "#F4CC54"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.278,
  cy: 25.734,
  r: 4.997,
  fill: "#FDD7AD"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.403 30.73h-.624a4.935 4.935 0 0 0-2.38.606 17.893 17.893 0 0 0 2.224 5.64H30.772v-1.25a4.98 4.98 0 0 0-2.616-4.39 4.935 4.935 0 0 0-2.38-.606h-4.373Zm-3.004.606a17.89 17.89 0 0 0 2.224 5.64h-4.84v-1.25a4.98 4.98 0 0 1 2.616-4.39Z",
  fill: "#405B73"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.264 18.238v6.246a1.253 1.253 0 0 1-1.249 1.25h-4.372l-3.342 2.38a.654.654 0 0 1-1.03-.532v-1.848h-1.25a1.253 1.253 0 0 1-1.248-1.25v-6.246a1.253 1.253 0 0 1 1.249-1.249h9.993c.69.002 1.247.56 1.25 1.25Z",
  fill: "#405B73"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.394 20.112h-3.123a.625.625 0 0 1 0-1.25h3.123a.625.625 0 1 1 0 1.25ZM40.766 22.61h-7.495a.625.625 0 1 1 0-1.249h7.495a.625.625 0 0 1 0 1.25Z",
  fill: "#F4CC54"
})));
export default SvgIconEinzel;